import { ValueOf } from '../../../type/util.type.ts';

export const CategoryLevel1_CODE = {
  GOODS: 'GOODS',
  HANDMADE: 'HANDMADE',
  BRAND_DEAL: 'BRAND_DEAL',
  EBOOK: 'EBOOK',
  CURATION: 'CURATION',
} as const;
export type CategoryLevel1_CODE = ValueOf<typeof CategoryLevel1_CODE>;

export const CategoryLevel2_CODE = {
  APPAREL: 'f6f882ba-fdc7-4bd8-bc93-66e1b532c998',
  KIDS: '03f4c597-0537-40b0-a73a-af4a169637a0',
  LIVING: '449cc8e6-943b-464d-b3c3-0882053b2747',
  PAPER: '4a930a5b-ac97-49a6-9624-8a37d9305b68',
  CONVENIENCE: '4f7ecac5-0f24-408a-b168-95fbd337d7ff',
  TOY_HOBBY: '5dc195d1-9ecc-4652-a453-f4f4e9138401',
  DIGITAL_GOODS: '5f05ba4b-048c-4dbb-a850-7ed1c3d71365',
  ACCESSORIES: 'fee992d1-7440-4a05-a928-4b4f31f73236',
  HANDMADE_DIY: '551b9ba0-a1db-4007-914a-c5750bd2c1fc',
  HANDMADE_GOODS: '32e08a87-1b38-4d07-b3a9-248e5fb6bb39',
  FAN_GOODS: '1937f5f2-9166-4137-9263-3ae37e31a1dc',
  FRAMES: 'b6e02248-884f-4e95-a3e3-848e59146948',
  STATIONERY: '185bcd7d-9eb6-4e42-bdb2-d4963f097a79',
  STICKER: '1d2c8621-16af-45ad-8628-4ac36bc17513',
  DIGITAL_TECH: 'd97fc989-1114-4642-b9df-085a9c98f8c9',
  FOOD: '847050c9-7087-4423-8270-10616ab002a1',
  SPORTS: 'bcc37567-98c1-47e9-b658-0848b6b9b644',
  PET: '699458b0-6d0b-4720-8620-9bd6e4d9a4f3',
  BOOKS_RECORDINGS: '05c261b1-ba2b-43a5-b669-313ce24bbdd8',
  STICKER_PAPER: '0facd860-2142-4af1-aad0-b4e29d3079d4',
  FABRIC: 'a261fb9e-a11e-4482-9e7e-4d797db6da27',
  E_COUPONS_TICKETS: '84aa685c-4270-4b20-82ed-04db909970fd',
  PHONE_ACC: '742764a4-b637-440e-a659-00f3347fdd6d',
  BEAUTY: 'e489c4e5-28fe-4b53-b202-10d169c268d7',
  EBOOK_TRAVEL_FOOD: '617fa5e2-5c05-4cb1-89b4-4b355cd7fd12',
  EBOOK_INVESTMENT: '2cf37f6b-dba7-4ecf-8d9f-4dbe36bf038e',
  EBOOK_JOB_EMPLOYMENT: 'f2629ef9-9828-479d-9731-3bc831546eed',
  EBOOK_LIFE_STYLE: '8a1a9352-b009-4421-99ff-f2a16d538946',
  EBOOK_EDUCATION: '9be8c803-f37f-4be1-a39e-9101dfabf5e5',
  EBOOK_RELIGION: 'cbf80ec5-b590-4a86-b395-5b1721de4f4c',
  EBOOK_DESIGN: 'a3a15c0e-d4a3-4fbc-8539-e974f81c9b4f',
  EBOOK_MUSIC: '7eeabf39-766d-48ed-8792-d3d6e65912d7',
  EBOOK_LITERATURE_CREATION: 'fe15121b-cda8-4aaf-8e4a-9bbfba1df143',
} as const;
export type CategoryLevel2_CODE = ValueOf<typeof CategoryLevel2_CODE>;

export const CategoryLevel3_CODE = {
  WALLPAPER: 'b611730b-cc66-494f-b52f-056ab494ed8e',
  VOICE_PACK: 'ffbdeaf0-8d87-414e-b14c-b1670a0ffb87',
  DIGITAL_ASSETS: '8d81b4d8-830d-4ea7-8457-ca195f8f05fc',
  GOODNOTES: '88e2aff0-e1c9-4293-9fac-605e14d3ec30',
} as const;
export type CategoryLevel3_CODE = ValueOf<typeof CategoryLevel3_CODE>;

export interface ICategory {
  readonly root_code: CategoryLevel1_CODE;
  readonly root_id: number;
  readonly id: number;
  readonly code: string;
  readonly level: number;
  readonly name: string | null;
  readonly sort_no: number | null;
  readonly name_en: string | null;
  readonly name_jp: string | null;
  readonly is_cloth: boolean;
  readonly children: ICategory[];
}

export interface CategoryIndex {
  level2: Set<string>;
  level3: Set<string>;
}

export type CategoryFilterLevel = 'level2' | 'level3';

// 실제 값 (string enum 값)을 기준으로 타입 만들기

// 전체 타입 정의
type CategoryLevel2ToLevel1Type = Partial<{
  [L2 in CategoryLevel2_CODE]: Partial<{
    [L1 in CategoryLevel1_CODE]?: { image: string; sort: number };
  }>;
}>;

// https://docs.google.com/spreadsheets/d/1WhbdIWPsvzGJlbUoVQrxYYbWZ_9GhGzegy8G7twMRps/edit?gid=1358174774#gid=1358174774
/**
 * https://marpple.slack.com/archives/C05Q5T9TH8S/p1752471758621109?thread_ts=1752034803.345959&cid=C05Q5T9TH8S
 * 정렬을 왜 하드코딩 하는가,
 * 데이터 구조상 대카테고리마다 중카테고리의 정렬을 지정할 수 없음
 * 하드코딩 해결도 나쁘지 않다고 판단,
 * */

export const CategoryLevel2ToLevel1Map: CategoryLevel2ToLevel1Type = {
  [CategoryLevel2_CODE.APPAREL]: {
    [CategoryLevel1_CODE.GOODS]: {
      image: '//s3.marpple.co/files/u_29089/2025/7/original/1f14d6c7ad2ff6d23765965248cecc373edb05dc12.png',
      sort: 1,
    },
    [CategoryLevel1_CODE.HANDMADE]: {
      image: '//s3.marpple.co/files/u_29089/2025/7/original/38d822fbd89277ce38669f3215071dccf9b1e47351.png',
      sort: 14,
    },
    [CategoryLevel1_CODE.BRAND_DEAL]: {
      image: '//s3.marpple.co/files/u_29089/2025/7/original/feb9e4a94267c614040ec07d30f79b74a9ebc8f629.png',
      sort: 7,
    },
  },
  [CategoryLevel2_CODE.FAN_GOODS]: {
    [CategoryLevel1_CODE.GOODS]: {
      image: '//s3.marpple.co/files/u_29089/2025/7/original/6cf842f4739aee7c7a31ff9bf490bfe7a8f2404e18.png',
      sort: 2,
    },
    [CategoryLevel1_CODE.HANDMADE]: { image: '', sort: 10 },
    [CategoryLevel1_CODE.BRAND_DEAL]: { image: '', sort: 10 },
  },
  [CategoryLevel2_CODE.STICKER]: {
    [CategoryLevel1_CODE.GOODS]: {
      image: '//s3.marpple.co/files/u_29089/2025/7/original/18a7d2978b5f619bc3492ffe9b93c158b40216c29.png',
      sort: 3,
    },
    [CategoryLevel1_CODE.HANDMADE]: { image: '', sort: 10 },
    [CategoryLevel1_CODE.BRAND_DEAL]: { image: '', sort: 10 },
  },
  [CategoryLevel2_CODE.PAPER]: {
    [CategoryLevel1_CODE.GOODS]: {
      image: '//s3.marpple.co/files/u_29089/2025/7/original/efbf984af4f4d835c7d9596b7597e9c21ab04a9913.png',
      sort: 4,
    },
    [CategoryLevel1_CODE.HANDMADE]: { image: '', sort: 10 },
    [CategoryLevel1_CODE.BRAND_DEAL]: { image: '', sort: 10 },
  },
  [CategoryLevel2_CODE.BOOKS_RECORDINGS]: {
    [CategoryLevel1_CODE.GOODS]: {
      image: '//s3.marpple.co/files/u_29089/2025/7/original/32df1ba8af5ca04c6a4c2101a378997fee1b66a42.png',
      sort: 5,
    },
    [CategoryLevel1_CODE.HANDMADE]: { image: '', sort: 10 },
    [CategoryLevel1_CODE.BRAND_DEAL]: { image: '', sort: 10 },
  },
  [CategoryLevel2_CODE.PHONE_ACC]: {
    [CategoryLevel1_CODE.GOODS]: {
      image: '//s3.marpple.co/files/u_29089/2025/7/original/1b9b2d79c3afdfecfac4d6a9e41066819f99eb9d6.png',
      sort: 6,
    },
    [CategoryLevel1_CODE.HANDMADE]: {
      image: '//s3.marpple.co/files/u_29089/2025/7/original/6ea03852e655e7112db31cd7f9972e8db6d5f85543.png',
      sort: 5,
    },
    [CategoryLevel1_CODE.BRAND_DEAL]: {
      image: '//s3.marpple.co/files/u_29089/2025/7/original/ee2e97a72cc6ceec44992ffb65ad55cb80310ab022.png',
      sort: 6,
    },
  },
  [CategoryLevel2_CODE.TOY_HOBBY]: {
    [CategoryLevel1_CODE.GOODS]: {
      image: '//s3.marpple.co/files/u_29089/2025/7/original/1bfffad455508fcbf776320230506b76df1e2a4416.png',
      sort: 7,
    },
    [CategoryLevel1_CODE.HANDMADE]: {
      image: '//s3.marpple.co/files/u_29089/2025/7/original/6065d62e8e2cc0c44b71a776245e0dbb6d3db44954.png',
      sort: 7,
    },
    [CategoryLevel1_CODE.BRAND_DEAL]: {
      image: '//s3.marpple.co/files/u_29089/2025/7/original/feb6f7faff8f2173be86d668b29b7852b5907ccf31.png',
      sort: 10,
    },
  },
  [CategoryLevel2_CODE.STATIONERY]: {
    [CategoryLevel1_CODE.GOODS]: {
      image: '//s3.marpple.co/files/u_29089/2025/7/original/e76d0bfee6ab5707da43c8afbec71a33dec731e17.png',
      sort: 8,
    },
    [CategoryLevel1_CODE.HANDMADE]: {
      image: '//s3.marpple.co/files/u_29089/2025/7/original/b86d9af484c7c4378e757de9e46edd1671c53b1e44.png',
      sort: 4,
    },
    [CategoryLevel1_CODE.BRAND_DEAL]: {
      image: '//s3.marpple.co/files/u_29089/2025/7/original/5b599b8bc6e98ce11ddea121fae1e5e8dc2603f223.png',
      sort: 11,
    },
  },
  [CategoryLevel2_CODE.DIGITAL_GOODS]: {
    [CategoryLevel1_CODE.GOODS]: {
      image: '//s3.marpple.co/files/u_29089/2025/7/original/bb74751d79092961827054f4cab01f310750a4f53.png',
      sort: 9,
    },
    [CategoryLevel1_CODE.HANDMADE]: { image: '', sort: 10 },
    [CategoryLevel1_CODE.BRAND_DEAL]: { image: '', sort: 10 },
  },
  [CategoryLevel2_CODE.FABRIC]: {
    [CategoryLevel1_CODE.GOODS]: {
      image: '//s3.marpple.co/files/u_29089/2025/7/original/1b369b17f195b1f55d414fd2855eea96962cb79c14.png',
      sort: 10,
    },
    [CategoryLevel1_CODE.HANDMADE]: {
      image: '//s3.marpple.co/files/u_29089/2025/7/original/127bf3774984de6b7ccdb56338f5227b6beac44952.png',
      sort: 6,
    },
    [CategoryLevel1_CODE.BRAND_DEAL]: { image: '', sort: 10 },
  },
  [CategoryLevel2_CODE.LIVING]: {
    [CategoryLevel1_CODE.GOODS]: {
      image: '//s3.marpple.co/files/u_29089/2025/7/original/3a8c7f4607493ca0d3a39d7a22029c12c675d4155.png',
      sort: 11,
    },
    [CategoryLevel1_CODE.HANDMADE]: {
      image: '//s3.marpple.co/files/u_29089/2025/7/original/40a43b7e84b6d284dce3305550867c95bf7efade42.png',
      sort: 3,
    },
    [CategoryLevel1_CODE.BRAND_DEAL]: {
      image: '//s3.marpple.co/files/u_29089/2025/7/original/4e47ab5abcfc7614e79cd09e91656e21b3f85c8f21.png',
      sort: 4,
    },
  },
  [CategoryLevel2_CODE.ACCESSORIES]: {
    [CategoryLevel1_CODE.GOODS]: {
      image: '//s3.marpple.co/files/u_29089/2025/7/original/b705ec8ca17b707412120a93ca6d374abd2b5bbe17.png',
      sort: 12,
    },
    [CategoryLevel1_CODE.HANDMADE]: {
      image: '//s3.marpple.co/files/u_29089/2025/7/original/bb60969b945ec27a747c54f0e24bf1120a3c136c55.png',
      sort: 2,
    },
    [CategoryLevel1_CODE.BRAND_DEAL]: {
      image: '//s3.marpple.co/files/u_29089/2025/7/original/4f21a4a4ff08ba56ac98425c7fed74fdc060f50332.png',
      sort: 8,
    },
  },
  [CategoryLevel2_CODE.FRAMES]: {
    [CategoryLevel1_CODE.GOODS]: {
      image: '//s3.marpple.co/files/u_29089/2025/7/original/88654a645f05f6c7a42e65741dc37bf328f0971c11.png',
      sort: 13,
    },
    [CategoryLevel1_CODE.HANDMADE]: {
      image: '//s3.marpple.co/files/u_29089/2025/7/original/e6e3b40583278302e2a807f7ce0084cf94db1dc850.png',
      sort: 9,
    },
    [CategoryLevel1_CODE.BRAND_DEAL]: { image: '', sort: 10 },
  },
  [CategoryLevel2_CODE.KIDS]: {
    [CategoryLevel1_CODE.GOODS]: {
      image: '//s3.marpple.co/files/u_29089/2025/7/original/5fb55f6c2936b4e3d2ef6f79a6b69686b012dbe515.png',
      sort: 14,
    },
    [CategoryLevel1_CODE.HANDMADE]: {
      image: '//s3.marpple.co/files/u_29089/2025/7/original/86ee99a00a815ae4e213b8d22a1786e2c60e764a53.png',
      sort: 13,
    },
    [CategoryLevel1_CODE.BRAND_DEAL]: {
      image: '//s3.marpple.co/files/u_29089/2025/7/original/73e6cf51ab983cb508441d391f12718fad8c417730.png',
      sort: 13,
    },
  },
  [CategoryLevel2_CODE.PET]: {
    [CategoryLevel1_CODE.GOODS]: {
      image: '//s3.marpple.co/files/u_29089/2025/7/original/799e3afd8bdd05374b4bb62cfe50c441869c7c558.png',
      sort: 15,
    },
    [CategoryLevel1_CODE.HANDMADE]: {
      image: '//s3.marpple.co/files/u_29089/2025/7/original/378df4854e002ccc98eb1937397951db516a4f9e45.png',
      sort: 12,
    },
    [CategoryLevel1_CODE.BRAND_DEAL]: {
      image: '//s3.marpple.co/files/u_29089/2025/7/original/b68ca1e3619565629fab8065093d4471262ee78924.png',
      sort: 12,
    },
  },
  [CategoryLevel2_CODE.SPORTS]: {
    [CategoryLevel1_CODE.GOODS]: {
      image: '//s3.marpple.co/files/u_29089/2025/7/original/3de38a02a9ecedf4454ea45121aedcd14935995410.png',
      sort: 16,
    },
    [CategoryLevel1_CODE.HANDMADE]: {
      image: '//s3.marpple.co/files/u_29089/2025/7/original/7caef9dbbc365d970cfdd79dddcdd4355fadcb8748.png',
      sort: 11,
    },
    [CategoryLevel1_CODE.BRAND_DEAL]: {
      image: '//s3.marpple.co/files/u_29089/2025/7/original/22fdbdcc05216920ebd86d897d30233f4f8ad06727.png',
      sort: 9,
    },
  },
  [CategoryLevel2_CODE.E_COUPONS_TICKETS]: {
    [CategoryLevel1_CODE.GOODS]: {
      image: '//s3.marpple.co/files/u_29089/2025/7/original/318f97fbbd127481d07aa363f7f0f428b24bb4ee19.png',
      sort: 17,
    },
    [CategoryLevel1_CODE.HANDMADE]: { image: '', sort: 10 },
    [CategoryLevel1_CODE.BRAND_DEAL]: { image: '', sort: 10 },
  },
  [CategoryLevel2_CODE.DIGITAL_TECH]: {
    [CategoryLevel1_CODE.GOODS]: {
      image: '//s3.marpple.co/files/u_29089/2025/7/original/a32f0111be6ebbf4aacc03cf293fb36946de6e134.png',
      sort: 18,
    },
    [CategoryLevel1_CODE.HANDMADE]: { image: '', sort: 10 },
    [CategoryLevel1_CODE.BRAND_DEAL]: {
      image: '//s3.marpple.co/files/u_29089/2025/7/original/9680b0fee9e29faeeec6b6131210e0fca39de88c20.png',
      sort: 5,
    },
  },

  [CategoryLevel2_CODE.CONVENIENCE]: {
    [CategoryLevel1_CODE.GOODS]: { image: '', sort: 10 },
    [CategoryLevel1_CODE.HANDMADE]: { image: '', sort: 10 },
    [CategoryLevel1_CODE.BRAND_DEAL]: {
      image: '//s3.marpple.co/files/u_29089/2025/7/original/3d75c803bfcff84695ad3a391993451b06bc7ef626.png',
      sort: 3,
    },
  },
  [CategoryLevel2_CODE.FOOD]: {
    [CategoryLevel1_CODE.GOODS]: { image: '', sort: 10 },
    [CategoryLevel1_CODE.HANDMADE]: {
      image: '//s3.marpple.co/files/u_29089/2025/7/original/ae5fb517d026a6da1deb7a727a3820883fb08fbc49.png',
      sort: 10,
    },
    [CategoryLevel1_CODE.BRAND_DEAL]: {
      image: '//s3.marpple.co/files/u_29089/2025/7/original/6df2e9134cd32f10e1504bfa2955f9832ac34bd728.png',
      sort: 1,
    },
  },
  [CategoryLevel2_CODE.STICKER_PAPER]: {
    [CategoryLevel1_CODE.GOODS]: { image: '', sort: 10 },
    [CategoryLevel1_CODE.HANDMADE]: {
      image: '//s3.marpple.co/files/u_29089/2025/7/original/3073c159afc577d97e0cb8f08ed48aa6914912e247.png',
      sort: 8,
    },
    [CategoryLevel1_CODE.BRAND_DEAL]: { image: '', sort: 10 },
  },
  [CategoryLevel2_CODE.BEAUTY]: {
    [CategoryLevel1_CODE.GOODS]: { image: '', sort: 10 },
    [CategoryLevel1_CODE.HANDMADE]: { image: '', sort: 10 },
    [CategoryLevel1_CODE.BRAND_DEAL]: {
      image: '//s3.marpple.co/files/u_29089/2025/7/original/4eb46e7eaa0da6ffa690248ddb827554a782909625.png',
      sort: 2,
    },
  },
  [CategoryLevel2_CODE.HANDMADE_DIY]: {
    [CategoryLevel1_CODE.GOODS]: { image: '', sort: 10 },
    [CategoryLevel1_CODE.HANDMADE]: { image: '', sort: 10 },
    [CategoryLevel1_CODE.BRAND_DEAL]: { image: '', sort: 10 },
  },
  [CategoryLevel2_CODE.HANDMADE_GOODS]: {
    [CategoryLevel1_CODE.GOODS]: { image: '', sort: 10 },
    [CategoryLevel1_CODE.HANDMADE]: {
      image: '//s3.marpple.co/files/u_29089/2025/7/original/83d363c1ac48a132fce14d70bdfcec5baff7e52c46.png',
      sort: 1,
    },
    [CategoryLevel1_CODE.BRAND_DEAL]: { image: '', sort: 10 },
  },

  [CategoryLevel2_CODE.EBOOK_TRAVEL_FOOD]: {
    [CategoryLevel1_CODE.EBOOK]: {
      image: '//s3.marpple.co/files/u_29089/2025/7/original/783cfb5c07e56d5fab1b7a94fa5a5fcf579f314e37.png',
      sort: 2,
    },
  },
  [CategoryLevel2_CODE.EBOOK_INVESTMENT]: {
    [CategoryLevel1_CODE.EBOOK]: {
      image: '//s3.marpple.co/files/u_29089/2025/7/original/a447f9e6d43b0bb2691f7931ef8ded61bfb7166041.png',
      sort: 5,
    },
  },
  [CategoryLevel2_CODE.EBOOK_JOB_EMPLOYMENT]: {
    [CategoryLevel1_CODE.EBOOK]: {
      image: '//s3.marpple.co/files/u_29089/2025/7/original/79d921e7ed7f34ff6f1486f32f8b302c6e36700a40.png',
      sort: 6,
    },
  },
  [CategoryLevel2_CODE.EBOOK_LIFE_STYLE]: {
    [CategoryLevel1_CODE.EBOOK]: {
      image: '//s3.marpple.co/files/u_29089/2025/7/original/bd48691d1e5e28e65a551386475a9eb72ca4d3a635.png',
      sort: 3,
    },
  },
  [CategoryLevel2_CODE.EBOOK_EDUCATION]: {
    [CategoryLevel1_CODE.EBOOK]: {
      image: '//s3.marpple.co/files/u_29089/2025/7/original/754e76a4c2dc7ee9c63bee63e5cb2f7d5562370533.png',
      sort: 1,
    },
  },
  [CategoryLevel2_CODE.EBOOK_RELIGION]: {
    [CategoryLevel1_CODE.EBOOK]: {
      image: '//s3.marpple.co/files/u_29089/2025/7/original/3bce8d1dfe313f7fcc17766092da16c5b03cc5ce39.png',
      sort: 9,
    },
  },
  [CategoryLevel2_CODE.EBOOK_DESIGN]: {
    [CategoryLevel1_CODE.EBOOK]: {
      image: '//s3.marpple.co/files/u_29089/2025/7/original/e30993210140b73bb730d72b4e8f9e2fd4e67d9f34.png',
      sort: 7,
    },
  },
  [CategoryLevel2_CODE.EBOOK_MUSIC]: {
    [CategoryLevel1_CODE.EBOOK]: {
      image: '//s3.marpple.co/files/u_29089/2025/7/original/738fa4d9cc91d354d1dd07f52572e8742d2987bc38.png',
      sort: 8,
    },
  },
  [CategoryLevel2_CODE.EBOOK_LITERATURE_CREATION]: {
    [CategoryLevel1_CODE.EBOOK]: {
      image: '//s3.marpple.co/files/u_29089/2025/7/original/5815921a9a3017400b03572200f891b4aee29fad36.png',
      sort: 4,
    },
  },
};
